/**
 * Bulk action bar (STN client round 2026-08): the fixed bottom-center pill
 * that appears while candidates are selected — "Contact all" (opens the
 * contact modal, live send since the 2026-08 finish line), Export (the
 * existing export-button popover, projected here from the toolbar), and
 * Clear. The mockup's "Save to project" left with the killed Projects concept.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'maps-bulk-action-bar',
    standalone: false,
    template: `
        <div class="bulk-bar" *ngIf="selectedCount > 0" role="toolbar" aria-label="Bulk actions" data-testid="bulk-bar">
            <span class="count">{{ selectedCount }} selected</span>
            <span class="divider" aria-hidden="true"></span>
            <button type="button" class="contact-all" data-testid="contact-all" (click)="contactAll.emit()">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                    <rect x="1.5" y="3" width="13" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.3" />
                    <path d="M2 4l6 5 6-5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
                </svg>
                Contact all
            </button>
            <maps-export-button
                [searchId]="searchId"
                [candidateIds]="candidateIds"
                [cap]="exportCap"></maps-export-button>
            <button type="button" class="clear" (click)="clearSelection.emit()">Clear</button>
        </div>
    `,
    styleUrl: './bulk-action-bar.component.scss',
})
export class BulkActionBarComponent {
    @Input({ required: true }) selectedCount = 0;
    @Input({ required: true }) searchId: string | null = null;
    @Input() candidateIds: string[] = [];
    @Input() exportCap = 30;
    @Output() clearSelection = new EventEmitter<void>();
    /** Open the contact modal with every selected candidate. */
    @Output() contactAll = new EventEmitter<void>();
}
